import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { eEstadoTipoVisita, ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { FilterConfiguracionDocumentoModel } from 'src/app/models/configuracion-documento/FilterConfiguracionDocumentoModel';
import { IConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IConfiguracionDocumentoModel';
import { IFilterConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IFilterConfiguracionDocumentoModel';
import { ITipoVisitaModel } from 'src/app/models/interfaces/tipo-visita/ITipoVisitaModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterTipoVisitaModel } from 'src/app/models/tipo-visita/FilterTipoVisitaModel';
import { ConfiguracionDocumentoService } from 'src/app/services/configuracion-documento/configuracion-documento.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoVisitaService } from 'src/app/services/tipo-visita/tipo-visita.service';

@Component({
  selector: 'app-configuracion-documento-listar',
  templateUrl: './configuracion-documento-listar.component.html',
  styleUrls: ['./configuracion-documento-listar.component.css']
})
export class ConfiguracionDocumentoListarComponent implements OnInit {
  model!: SearchResultModel<IConfiguracionDocumentoModel[]>;
  filter: IFilterConfiguracionDocumentoModel = new FilterConfiguracionDocumentoModel();
  resultsLength = 0;
  currentPage = 0;

  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  listaTipoVisitas: ITipoVisitaModel[] = new Array<ITipoVisitaModel>();

  displayedColumns: string[] = [
    'id',
    'documento',
    'tipoVisita',
    'seccion',
    'restringeAccesos', 
    'idRequisito', 
    'controlarFechas', 
    'esPredeterminado',
    'acciones'
  ];

  @ViewChild('paginator') paginator!: MatPaginator;
  
  constructor(
    private configuracionDocumentoService: ConfiguracionDocumentoService,
    private tipoVisitaService: TipoVisitaService,
    private serviceParametros: ParametroService
  ) { 
    this.model = new SearchResultModel<IConfiguracionDocumentoModel[]>(false, new Array<IConfiguracionDocumentoModel>(), 0, 1, 0);    
  }

  ngOnInit(): void {
    let filterTipoVisita = new FilterTipoVisitaModel();
    filterTipoVisita.idEstado = eEstadoTipoVisita.ACTIVO;
    this.tipoVisitaService.getList(filterTipoVisita).subscribe((data) => {
      this.listaTipoVisitas = data;
    });
    
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_DOCUMENTO).subscribe((data) => {
      this.listaEstados = data.items;
    });

    this.search();
  }

  search(): void{
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.configuracionDocumentoService
      .getListPaged(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.configuracionDocumentoService
      .getListPaged(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }
}
